export const offlineQueueSettings = {
  CHECK_INTERVAL: 10 * 1000, // 10 seconds - check queue every X seconds
  MAX_RETIRES: 13, // max retries for each request - 2 at power of 13 = 8192 / 60 / 24 = 5,68 days
  RETRY_DELAY: 1 * 60 * 1000, // 1 minute - will be multiplied with powers of two for progressive delaying
  RETRIES_PER_RUN: 10 // process requests in bulks of X
};
